import React from "react";
import { TransferIcon } from "../../../../styles/img/svg/TransferIcon";
import { BillPaymentIcon } from "../../../../styles/img/svg/BillPaymentIcon";
import { ArrowBack } from "@mui/icons-material";
import { UiWhiteCard } from "../../../_uiComponents/common/UiWhiteCard";
import { UiScheduleCard } from "../../../_uiComponents/SchedulePayments/UiScheduleCard";
import { useNavigate } from "react-router-dom";
import { schedulePaymentsConstants } from "../../../../_redux/_constants/schedulePayments.constant";
import {
  setActiveView,
  setNavigateFrom,
  clearState,
} from "../../../../_redux/_actions/schedulePayments.actions";
import { useDispatch } from "react-redux";
import TransferIconImg from "../../../../styles/img/sche_fund_transfer.png";
import BillPaymentIconImg from "../../../../styles/img/sche_bill_payment.png";

export const SchedulePaymentsTypeSelect = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navigateToFundTransfer = () => {
    dispatch(
      setNavigateFrom(
        schedulePaymentsConstants.NAVIGATE_FROM_SCHEDULE_PAYMENTS,
      ),
    );
    navigate("/app/fund-transfer");
  };

  const navigateToBillPayment = () => {
    dispatch(
      setNavigateFrom(
        schedulePaymentsConstants.NAVIGATE_FROM_SCHEDULE_PAYMENTS,
      ),
    );
    navigate("/app/bill-payments");
  };

  const backtoSchedulePayments = () => {
    dispatch(clearState());
    dispatch(setActiveView());
  };

  return (
    <div className="df-db-left">
      <UiWhiteCard className="mt-0 df-setting-front-card df-mh-wf">
        <div className="df-search-top-bar__paginate">
          <h2 onClick={backtoSchedulePayments}>
            <ArrowBack /> Schedule Payment
          </h2>
        </div>

        <UiScheduleCard
          logo={<TransferIcon icon={TransferIconImg} />}
          title="Schedule a Fund Transfer"
          onClick={navigateToFundTransfer}
        />

        <UiScheduleCard
          logo={<BillPaymentIcon icon={BillPaymentIconImg} />}
          title="Schedule a Bill Payment"
          onClick={navigateToBillPayment}
        />

        {/* <UiScheduleCard
          logo={<SettleCardIcon />}
          title="Schedule a Card Payment"
          onClick={toAccPref}
        /> */}
      </UiWhiteCard>
    </div>
  );
};
